export const RECORD_ACCESS_LOGIN_VERIFIED_KEY = "recordAccessLoginVerified";

export const getLoggedInUserId = () => {
  try {
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    return userData?.userId ?? null;
  } catch {
    return null;
  }
};

export const isLoginPasswordVerified = (userId = getLoggedInUserId()) => {
  if (!userId) return false;

  try {
    const stored = JSON.parse(
      localStorage.getItem(RECORD_ACCESS_LOGIN_VERIFIED_KEY) || "null",
    );
    return stored?.userId === userId;
  } catch {
    return false;
  }
};

export const markLoginPasswordVerified = (userId = getLoggedInUserId()) => {
  if (!userId) return;

  localStorage.setItem(
    RECORD_ACCESS_LOGIN_VERIFIED_KEY,
    JSON.stringify({ userId }),
  );
};

export const clearLoginPasswordVerification = () => {
  localStorage.removeItem(RECORD_ACCESS_LOGIN_VERIFIED_KEY);
};
